import { Pipe, PipeTransform } from '@angular/core';
import { AttributeDefinition } from '../models/attributes/attributeDefinition';
import { Attribute } from '../models/attributes/attribute';

@Pipe({
  name: 'customFieldValueByIdPipe',
  standalone: false
})
export class CustomFieldValueByIdPipe implements PipeTransform {
  transform(customFieldValues: Attribute[], id: string): Array<Attribute> {
    return customFieldValues.filter((a) => a.attributeDefinitionId == id);
  }
}
